const LogLevel = {
  /** 普通日志 */
  Log: 0,
  /** 警告日志 */
  Warning: 1,
  /** 错误日志 */
  Error: 2,
};

const Styles = ["color: green;", "color: orange;", "color: red;"];
const Methods = ["info", "warn", "error"];

export default class Logger {
  static _log(level, args) {
    // 只在真正的production环境（非test）禁用日志
    if (
      process.env.NODE_ENV === "production" &&
      process.env.REACT_APP_ENV !== "test"
    )
      return;

    if (navigator.userAgent.toLowerCase().indexOf("jiajiaclass") > -1) {
      console.log(...args);
    } else {
      console[Methods[level]](
        `%c${Methods[level].toUpperCase()}:`,
        Styles[level],
        ...args
      );
    }
  }

  /**
   * print normal information
   *
   * @param args any argument
   */
  static info(...args) {
    this._log(LogLevel.Log, args);

    return this;
  }

  /**
   * print waring msg
   *
   * @param args any arguments
   */
  static warn(...args) {
    this._log(LogLevel.Warning, args);
    return this;
  }

  /**
   * print error msg
   *
   * @param args
   */
  static error(...args) {
    this._log(LogLevel.Error, args);
    return this;
  }
}
